module.exports = __webpack_public_path__ + "fonts/NanumSquareOTFB.06f8f17d.woff2";